// Module
var code = "<div class=\"form-control\"></div>";
// Exports
export default code;